import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import Loader from 'oxyrion-ui/lib/Loader';
import ImageGallery from 'react-image-gallery';
import { getIdFromProps, __, translate } from '../../Utils';
import API2 from '../../API2';
import { LoaderWrapper } from '../../Components/ReusableComponents';
import ErrorMessage from '../../Components/ErrorMessage';
import Article from '../../Components/Article';
import Documentation from '../ProductCatalog/Components/Documentation';
import { connect } from '../../Store';
import '../../../node_modules/react-image-gallery/styles/scss/image-gallery.scss';
import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

const GalleryWrapper = styled.div`
  max-width: 700px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const AttachmentsWrapper = styled.div`
  width: 100%;
  max-width: ${rem(1400)};
  margin: ${rem(24)};
`;
const AttachmentsLabel = styled.h1`
  font-weight: bold;
  font-size: ${rem(16)};
`;

class NewsDetail extends Component {
  state = {
    loading: true,
  };
  async componentDidMount() {
    const id = getIdFromProps(this.props);
    try {
      const article = await API2.getNewsAction(id);
      if (article.attachments) {
        article.attachments = article.attachments.map(a => ({
          name: a.name,
          _id: a.fullPath,
          file: {
            fullPath: a.fullPath,
            mimeType: a.mimeType,
            name: a.name,
            _id: a.fullPath,
          },
        }));
      }

      this.setState({
        article,
        loading: false,
      });
    } catch (e) {
      this.setState({
        error: __('Článok sa nepodarilo zobraziť'),
        loading: false,
      });
    }
  }
  async downloadFile(path) {
    // const { article } = this.state;
    // ENDPOINT NEEXISTUJE
    // return API2.getB2BNewsAttachmentAction(
    //   article._id,
    //   encodeURIComponent(path),
    // );
  }
  render() {
    const { loading, article, error } = this.state;
    return (
      <Wrapper>
        <ErrorMessage display={error} text={error} />
        {loading && (
          <LoaderWrapper style={{ width: '100%' }}>
            <Loader size="xl" />
          </LoaderWrapper>
        )}
        {article && (
          <React.Fragment>
            <Article
              name={article.name}
              firm={this.props.appLang}
              perex={article.perex}
              text={article.text}
              thumbnail={article.thumbnail}
              updated={article.updated_date}
              videos={article.videos || []}
              content={translate(
                this.props.user.appLang,
                article.text.translations,
                article.text.value,
              )}
              html_data={
                article.html_data &&
                translate(
                  this.props.user.appLang,
                  article.html_data.translations,
                  article.html_data.value,
                )
              }
            />
            {article.images && (
              <GalleryWrapper>
                <ImageGallery
                  items={article.images
                    .filter(
                      i =>
                        !i.firms ||
                        (i.firms &&
                          i.firms.indexOf(this.props.user.appLang) > -1),
                    )
                    .map(i => {
                      return {
                        original: `https://api-v2.oxyrion.com/images/0x0/${
                          i.fullPath
                        }`,
                        thumbnail: `https://api-v2.oxyrion.com/images/250x150/${
                          i.fullPath
                        }`,
                      };
                    })}
                />
              </GalleryWrapper>
            )}

            {article.attachments && article.attachments.length > 0 && (
              <AttachmentsWrapper>
                <AttachmentsLabel>{__('Prílohy')}</AttachmentsLabel>
                <Documentation
                  files={article.attachments}
                  downloadFile={path => {
                    return this.downloadFile(path);
                  }}
                  onError={() =>
                    this.setState({
                      error: __('Súbor sa nepodarilo stiahnúť'),
                    })
                  }
                  history={this.props.history}
                />
              </AttachmentsWrapper>
            )}
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

NewsDetail.propTypes = {
  appLang: PropTypes.string.isRequired,
  history: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(NewsDetail);



// WEBPACK FOOTER //
// ./src/Containers/NewsDetail/index.jsx